import type { SVGProps } from 'react'
const SvgContactMail = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="contact-mail_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#contact-mail_svg__a)">
      <path d="M10.491 8.237h5.156V4.536H10.49zm2.58-.933L11.21 6v-.75l1.861 1.304 1.862-1.304V6zM1.706 15.817q-.708 0-1.207-.499A1.64 1.64 0 0 1 0 14.111V3.889q0-.708.499-1.207a1.64 1.64 0 0 1 1.207-.5h14.588q.709 0 1.207.5.5.498.499 1.207v10.222q0 .708-.499 1.207a1.65 1.65 0 0 1-1.207.5zm10.358-1.634h4.297V3.817H1.639v10.366h.075a5.7 5.7 0 0 1 2.175-2.203 5.9 5.9 0 0 1 3-.797q1.613 0 3 .797a5.7 5.7 0 0 1 2.175 2.203m-5.188-3.719q.954 0 1.618-.663.663-.663.663-1.618a2.2 2.2 0 0 0-.663-1.62 2.2 2.2 0 0 0-1.618-.666q-.956 0-1.621.665a2.2 2.2 0 0 0-.665 1.62q0 .956.665 1.62a2.2 2.2 0 0 0 1.62.662m-3.154 3.719h6.303a4.4 4.4 0 0 0-1.434-1.006 4.2 4.2 0 0 0-1.716-.36q-.897 0-1.71.36a4.6 4.6 0 0 0-1.443 1.006m3.154-5.286a.7.7 0 0 1-.512-.205.7.7 0 0 1-.207-.51q0-.305.207-.511a.7.7 0 0 1 .511-.207q.306 0 .51.207a.7.7 0 0 1 .205.512.7.7 0 0 1-.206.51.7.7 0 0 1-.508.204" />
    </g>
  </svg>
)
export default SvgContactMail
